module.exports = __webpack_public_path__ + "img/product4.0e0d14b.png";